import { MainNavigation } from './MainNavigation';
import { NavigationItem } from '../hooks/useNavigation';

interface SidebarContentProps {
  navigation: NavigationItem[];
  currentSubmenu: string | null;
  onOracleClick: () => void;
  onBackClick: () => void;
}

export function SidebarContent({ navigation, onOracleClick }: SidebarContentProps) {
  return (
    <nav className="flex-1 overflow-y-auto pt-2 relative overflow-x-hidden">
      {/* Main Navigation */}
      <MainNavigation isVisible={true} navigation={navigation} onOracleClick={onOracleClick} />
    </nav>
  );
}
